<template>
	<div
	 class="product"
	 v-if="item.scan !== 'error'"
	>
		<div
		 class="product__top"
		 v-if="item.scan === 'replace'"
		>
			<div class="product__warningMessage">
				<label>{{resource('replaceArticle')}}</label>
				<icon
				 name="stickArrow"
				 direction="down"
				/>
				<span v-html="getWarningMessage"></span>
			</div>
		</div>
		<div class="product__bottom">
			<div class="product__image">
				<lazy-img
				 :src="imgSrc"
				 :title="content('name')"
				/>
			</div>
			<div class="product__name">{{content('name')}}</div>
			<div class="product__ean">{{item.ean}}</div>
			<div class="product__brand">{{content('brand')}}</div>
			<div
			 class="product__scan"
			 :class="'product__scan--' + item.scan"
			>{{label}}</div>
			<div class="product__order-qty">{{item.orderQuantity}}</div>
			<div class="product__price">{{item.price | price}}</div>
			<div class="product__amount">
				<numberInput
				 :amount="item.amount"
				 :steps="item.orderQuantity"
				 :min="item.orderQuantity"
				 :max="999"
				 @update="updateProduct($event)"
				/>
			</div>
			<div class="product__total">{{total | price}}</div>
			<div class="product__select">
				<input
				 type="checkbox"
				 v-model="idState.isItemSelected"
				 @change="selected()"
				>
			</div>
		</div>
	</div>

	<div
	 class="product"
	 v-else
	>
		<div class="product__top"></div>
		<div class="product__bottom">
			<div class="product__name">{{resource('invalidScan')}}</div>
			<div class="product__ean">{{item.ean}}</div>
			<div
			 class="product__scan"
			 :class="'product__scan--' + item.scan"
			>{{label}}</div>
			<div
			 class="product__search"
			 @click="openSearch"
			>
				<icon name="search" />
				{{resource('searchReplacement')}}
			</div>
			<div class="product__select">
				<input
				 type="checkbox"
				 v-model="idState.isItemSelected"
				 @change="selected()"
				>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
.product {
	padding: $product__padding;
	position: relative;
	font-size: $product__fs;
	padding: 0.5rem;

	> * {
		flex: 0 0 auto;
	}
	&__top {
		grid-row: 1;
	}
	&__bottom {
		grid-row: 2;
		display: grid;
		grid-template-columns: 60px 1fr 120px 70px 70px 30px 70px 130px 60px 40px;
		grid-template-areas: "image name ean brand scan orderQuantity price amount total select";
		grid-gap: $product__padding;
		align-items: center;
		position: relative;
		font-size: $product__fs;
		padding: 0.5rem;
	}
	&__warningMessage {
		border: 1px solid $warning;
		border-radius: 3px;
		min-height: 28px;
		display: grid;
		grid-template-columns: 130px auto;
		grid-template-areas: "label message";
		position: relative;
		label {
			justify-self: stretch;
			background: $warning;
			text-align: center;
			color: #fff;
			display: flex;
			grid-area: label;
			padding: 3px 0;
			align-items: center;
			justify-content: center;
		}
		span {
			background: #ededed;
			color: #6b6b6b;
			grid-area: message;
			padding: 3px 10px;
		}
		.icon {
			position: absolute;
			fill: $warning;
			left: 130px;
			bottom: -1em;
			width: 1.2em;
			height: 1.2em;
		}
	}
	&__image {
		grid-area: image;
		width: 60px;
		height: 60px;
		align-items: center;
		display: flex;
	}
	&__name {
		grid-area: name;
		word-break: break-word;
	}
	&__ean {
		grid-area: ean;
	}
	&__brand {
		grid-area: brand;
	}
	&__scan {
		grid-area: scan;
		padding: $component;
		border-radius: 3px;
		color: #fff;
		text-align: center;
		line-height: 1em;
		&--ok {
			background: $ok;
		}
		&--replace {
			background: $warning;
		}
		&--error {
			background: $error;
		}
	}
	&__orderQty {
		grid-area: orderQuantity;
	}
	&__price {
		grid-area: price;
	}
	&__amount {
		grid-area: amount;
	}
	&__total {
		grid-area: total;
	}
	&__select {
		grid-area: select;
		text-align: center;
	}
	&__search {
		grid-area: 1 / 5 / 1 / -2;
		text-align: center;
		cursor: pointer;
		text-decoration: underline;
		svg {
			margin-right: $component;
		}
	}
}
.number-input {
	width: 100%;
}

input[type="checkbox"] {
	appearance: none;
	border: 1px solid #ccc;
	width: 20px;
	height: 20px;
	border-radius: 3px;
	position: relative;
	cursor: pointer;
	&:checked {
		&:after {
			content: "✓";
			width: 100%;
			height: 100%;
			position: absolute;
			left: 0;
			top: 0;
			display: flex;
			justify-content: center;
			align-items: center;
			color: $secondary;
			font-weight: bold;
			font-size: 18px;
		}
	}
}

.replaced-ean {
	color: $warning;
	font-weight: bold;
	svg {
		vertical-align: middle;
		margin-right: 3px;
		position: relative;
		top: -2px;
	}
}
</style>

<script>
import numberInput from '../components/numberInput.vue'
import lazyImg from '../components/lazy-img.vue'
import { IdState } from 'vue-virtual-scroller'

export default {
	mixins: [
		IdState({
			// You can customize this
			idProp: vm => vm.item.id
		})
	],
	name: 'productItem',
	components: {
		numberInput,
		lazyImg
	},
	mounted() {
		document.addEventListener('uncheckProducts', this.uncheck)
	},
	destroyed() {
		document.removeEventListener('uncheckProducts', this.uncheck)
	},
	computed: {
		lang() {
			return this.$store.getters.language
		},
		total() {
			var price = {
				amount: this.item.price.amount * this.item.amount,
				currency: this.item.price.currency
			}
			return price
		},
		label() {
			var labelText
			switch (this.item.scan) {
			case 'ok':
				labelText = this.resource('okScan')
				break
			case 'error':
				labelText = this.resource('errorScan')
				break
			case 'replace':
				labelText = this.resource('replaceScan')
				break
			default:
				labelText = ''
				break
			}
			return labelText
		},
		imgSrc() {
			let ean = this.item.ean
			let baseUrl =
				'https://cdn.nextchapter-ecommerce.com/clients/pgz/pgz-scanner/'
			let imgSrc = baseUrl + ean + '.jpg'
			return imgSrc
		},
		getWarningMessage() {
			let lang = this.lang

			let ean = this.item.replaces
			let replacedItem = this.$store.getters.product(this.item.replaces)
			let name = replacedItem.content[lang].name

			if (lang === 'nl') {
				return `<i>LET OP:</i> het product <strong>${name}</strong> met EAN <strong>${ean}</strong> is vervangen door een nieuw artikel`
			}

			if (lang === 'fr') {
				return `<i>REMARQUE:</i> le produit <strong>${name}</strong> avec EAN <strong>${ean}</strong> a été remplacé par un nouvelle article`
			}
		}
	},
	model: {
		prop: 'item'
	},
	props: {
		item: {
			require: true
		}
	},
	idState() {
		return {
			isItemSelected: false
		}
	},
	data() {
		return {
			res: {
				nl: {
					yes: 'Ja',
					cancel: 'Annuleer',
					invalidScan: 'Ongeldige scan',
					searchReplacement: 'Zoek vervangend artikel',
					okScan: 'Scan OK',
					errorScan: 'Ongeldig',
					replaceScan: 'Vervang artikel',
					replaceArticle: 'Vervangartikel'
				},
				fr: {
					yes: 'Oui',
					cancel: 'Annuler',
					invalidScan: 'Scan invalide',
					searchReplacement: 'Rechercher un article de remplacement',
					okScan: 'Scan OK',
					errorScan: 'Invalide',
					replaceScan: 'Remplacer l\'article',
					replaceArticle: 'Remplacer l\'article'
				}
			}
		}
	},
	methods: {
		resource(item) {
			var lang = this.lang
			return this.res[lang][item]
		},

		getReplacedProductContent(item) {
			let replacedItem = this.$store.getters.product(this.item.replaces)

			var lang = this.lang
			var prodItem = replacedItem.content
			return prodItem[lang][item]
		},
		content(item) {
			var lang = this.lang
			var prodItem = this.item.content
			return prodItem[lang][item]
		},
		updateProduct(msg) {
			this.$emit('update', msg)
			if (typeof msg === 'number') {
				this.item.amount = msg
			}
		},
		openSearch() {
			this.$emit('openSearch')
		},
		selected() {
			this.$emit('selected', this.idState.isItemSelected)
		},
		uncheck() {
			this.idState.isItemSelected = false
		}
	}
}
</script>